import './collage.scss';

import { getOffset, smoothScrollTo } from '../../js/helper';

class Collage {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-collage',
            contentAttr: 'content',
            emotionAttr: 'emotion',
            toggleAttr: 'toggle',
            offset: 1
        };

        this.settings = Object.assign({}, defaults, options);

        this.$collage = element;
        this.$collageEmotions = this.$collage.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.emotionAttr + '"]');
        this.$header = document.querySelector('[data-header="root"]');
    }

    initialize () {
        if (this.$collageEmotions.length > 0) {
            this.setEvents();
        }
    }

    resetEmotions ($current) {
        for (let i = 0; i < this.$collageEmotions.length; i++) {
            const $emotion = this.$collageEmotions[i];
            const $toggle = $emotion.querySelector('[' + this.settings.initAttr + '="' + this.settings.toggleAttr + '"]');

            if ($current !== $toggle) {
                $emotion.classList.remove('is--active');
                $toggle.checked = false;
            }
        }
    }

    setEvents () {
        for (let i = 0; i < this.$collageEmotions.length; i++) {
            const $emotion = this.$collageEmotions[i];
            const $emotionContent = $emotion.querySelector('[' + this.settings.initAttr + '="' + this.settings.contentAttr + '"]');
            const $toggle = $emotion.querySelector('[' + this.settings.initAttr + '="' + this.settings.toggleAttr + '"]');

            if ($toggle !== null) {
                $toggle.addEventListener('change', () => {
                    this.resetEmotions($toggle);

                    if ($toggle.checked === true) {
                        $emotion.classList.add('is--active');

                        const position = getOffset($emotionContent);

                        let offset = this.settings.offset;
                        if (this.$header !== null) {
                            offset = this.$header.offsetHeight;
                        }
                        smoothScrollTo(0, position.top - offset, 250);
                    } else {
                        $emotion.classList.remove('is--active');
                    }
                });
            }
        }
    }
}

export { Collage };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $collages = $context.querySelectorAll('[data-collage="root"]');

        if ($collages.length > 0) {
            for (let i = 0; i < $collages.length; i++) {
                const $collage = new Collage($collages[i]);
                $collage.initialize();
            }
        }
    }
});
